module.exports = __webpack_public_path__ + "img/iOS_miaoshu.ed1fa5f3.png";